import { createFileRoute } from "@tanstack/react-router";
import { RootRedirectClient } from "@/components/auth/root-redirect-client";

export const Route = createFileRoute("/")({
  component: Home,
});

function Home() {
  return <RootRedirectClient />;
}
